import { Vue } from './config'
import CurrencyInput from '../components/CurrencyInput'
import NumberInput from '../components/NumberInput'

if (document.getElementById('vue-pensioncalc')) {

    var fund = new Vue({
        el: '#vue-pensioncalc',
        components: {
            CurrencyInput,
            NumberInput
        },
        data: {
            annualIncome: 20000,
            initialInvestment: 5000,
            growthRate: 0.05,
            drawdownRate: 0.025,
            lifeExpectancy: 90,
            currentAge: 45,
            retirementAge: 65
        },
        methods: {
            format(value) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
        },
        computed: {
            monthlyIncome: function () {
                return this.annualIncome / 12
            },
            monthlyDrawdownRate: function () {
                return this.drawdownRate / 12
            },
            monthlyGrowthRate: function () {
                return this.growthRate / 12
            },
            drawDownMonths: function () {
                return (this.lifeExpectancy - this.retirementAge) * 12
            },
            savingMonths: function () {
                return this.years * 12
            },
            initialInvestmentGrowth: function () {
                return this.initialInvestment * Math.pow(1 + this.monthlyGrowthRate, this.savingMonths)
            },
            totalPot: function () {
                var pot = this.monthlyIncome * (1 - Math.pow((1 + this.monthlyDrawdownRate), -this.drawDownMonths)) / this.monthlyDrawdownRate
                var net = pot - this.initialInvestmentGrowth
                return net
            },
            years: function () {
                return this.retirementAge - this.currentAge
            },
            monthlyContribution: function () {
                var p = Math.pow((1 + this.monthlyGrowthRate), this.savingMonths)
                return Math.abs(this.totalPot / ((1 - p) / this.monthlyGrowthRate))
            },
            annualIncomeFormatted: function () {
                return this.format(this.annualIncome)
            },
            monthlyContributionFormatted: function () {
                return this.format(Math.round(this.monthlyContribution))
            },
            totalPotFormatted: function () {
                return this.format(Math.round(this.totalPot))
            }
        },
        mounted: function () {
        },

    })
}